import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

// import { styled } from '@mui/material/styles';

import { FC, useEffect } from 'react';
import { EventsBreadCrumb } from 'src/components/events/EventsBreadCrumb';

const AboutView: FC<{}> = () => {


    useEffect(() => {
        window.scrollTo(0, 0);
    });

    return (
        <>
            <EventsBreadCrumb event={undefined} />
            <Grid container>
                <Grid size={{ md: 2, lg: 3, xl: 4 }}>

                </Grid>
                <Grid size={{ md: 8, lg: 6, xl: 4 }}>

                    <Typography align='center' variant='h1'>eventbild.se</Typography>
                    <Typography align='center' variant='h5'>av Fredrik Mörk</Typography>
                    <Box>
                        <img
                            // className={classes.portraitImage}
                            style={{
                                display: 'inline',
                                float: 'right'
                            }}
                            src="https://www.gravatar.com/avatar/f40ccff29d3ac083ca1cb511d8824b2f?s=180&amp;d=identicon&amp;r=PG" alt=""
                            width="180" height="180" />
                        <Typography>
                            Välkommen till eventbild.se! Här publicerar jag foton som jag har tagit vid olika events, och där du kan köpa bilder för digital nedladdning. Jag är verksam främst i Skåne.
                        </Typography>
                        <Typography>
                            Bilder som du köper för nedladdning levereras givetvis utan vattenstämplar eller text.
                        </Typography>
                        <Typography>
                            Tipsa mig gärna om events där du tycker att jag borde fotografera. Du kan också anlita mig som fotograf. Eventet läggs då upp här som en privat
                            länk som du kan sprida till de som ska ha tillgång till bilderna.
                        </Typography>
                        <Typography>
                            Jag är även aktiv som naturfotograf. De bilderna publicerar jag på <a href="https://www.instagram.com/photosbyfmork/" title="@photosbyfmork på Instagram">Instagram</a> och på <a href="https://www.photosbyfmork.com">www.photosbyfmork.com</a>.
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{ md: 2, lg: 3, xl: 4 }}>

                </Grid>
            </Grid>
        </>
    )
}

export default AboutView
